export const iconFontAwesomeWritingPen = (
	<i className="fa-solid fa-pen"></i>
);
